import { render, staticRenderFns } from "./ApplyInfo.vue?vue&type=template&id=04820835&scoped=true"
import script from "./ApplyInfo.vue?vue&type=script&lang=js"
export * from "./ApplyInfo.vue?vue&type=script&lang=js"
import style0 from "./ApplyInfo.vue?vue&type=style&index=0&id=04820835&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04820835",
  null
  
)

export default component.exports